import React, { useEffect, useState } from "react";
import Header from "../../Components/Header/Header";
import PageHeadings from "../../Components/PageHeadings/PageHeadings";
import FiltersSidebar from "../../Components/FiltersSidebar/FiltersSidebar";
import DashboardsCards from "../../Components/DashboardCards/DashboardsCards";
import Footer from "../../Components/Footer/Footer";
import { useLocation, useParams } from "react-router-dom";
import { APIUrl, APIUrlToken } from "../../Utils/Utils";
import axios from "axios";
import { toast } from "react-toastify";

// ── Hawaii configuration ─────────────────────────────────────────────────────
// Maps sport_id → team_id for all Hawaii teams
const HAWAII_TEAM_MAP = {
  1:  882,
  2:  883,
  3:  889,
  4:  884,
  5:  885,
  6:  886,
  7:  887,
  8:  888,
  9:  890,
  10: 891,
  11: 892,
  12: 893,
  13: 894,
  14: 895,
  15: 896,
  16: 897,
  17: 898,
  18: 899,
  19: 900,
};

// Maps sport_id → team display name
const HAWAII_TEAM_NAMES = {
  1:  "Hawai'i Rainbow Warriors",
  2:  "Hawai'i Rainbow Warriors",
  4:  "Hawai'i Rainbow Warriors",
  5:  "Hawai'i Rainbow Warriors",
  6:  "Hawai'i Rainbow Warriors",
  7:  "Hawai'i Rainbow Warriors",
  8:  "Hawai'i Rainbow Warriors",
  3:  "Hawai'i Rainbow Wahine",
  9:  "Hawai'i Rainbow Wahine",
  10: "Hawai'i Rainbow Wahine",
  11: "Hawai'i Rainbow Wahine",
  12: "Hawai'i Rainbow Wahine",
  13: "Hawai'i Rainbow Wahine",
  14: "Hawai'i Rainbow Wahine",
  15: "Hawai'i Rainbow Wahine",
  16: "Hawai'i Rainbow Wahine",
  17: "Hawai'i Rainbow Wahine",
  18: "Hawai'i Rainbow Wahine",
  19: "Hawai'i Rainbow Wahine",
};
// ─────────────────────────────────────────────────────────────────────────────

const Dashboard = ({ mode = "both" }) => {
  const { sportId, teamId, playerId } = useParams();

  // ── Detect Hawaii route ──────────────────────────────────────────────────
  const isHawaii = window.location.pathname.toLowerCase().includes("/hawaii");
  const hawaiiSportId = isHawaii && sportId ? Number(sportId) : null;
  const hawaiiTeamId  = hawaiiSportId ? HAWAII_TEAM_MAP[hawaiiSportId] : null;

  // Use resolved IDs: on hawaii routes, override teamId/sportId with Hawaii values
  const effectiveSportId = isHawaii ? (hawaiiSportId ? String(hawaiiSportId) : sportId) : sportId;
  const effectiveTeamId  = isHawaii ? (hawaiiTeamId  ? String(hawaiiTeamId)  : teamId)  : teamId;
  // ─────────────────────────────────────────────────────────────────────────

  const [skip, setSkip] = useState(0);
  const [loading, setLoading] = useState(false);
  const [players, setPlayers] = useState([]);
  const [playersCount, setPlayersCount] = useState(0);
  const [isFiltered, setIsFiltered] = useState(false);
  const [open, setOpen] = useState(false);
  const [maxWeight, setMaxWeight] = useState("");
  const [isSearch, setIsSearch] = useState(false);
  const [apiCalled, setApiCalled] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [loadedPlayer, setLoadedPlayer] = useState(null);
  const showContribute = mode !== "collab";
  const showCollab = mode !== "contribute";
  const location = useLocation();
  const { sportIdHome, sportLabel } = location.state || {};

  // Hard-coded sport labels
  const sportMap = {
    1: "Men's Basketball",
  2: "Men's Football",
  3: "Women's Basketball",
  4: "Men's Baseball",
  5: "Men's Golf",
  6: "Men's Swimming and Diving",
  7: "Men's Tennis",
  8: "Men's Volleyball",
  9: "Women's Beach Volleyball",
  10: "Women's Cross Country",
  11: "Women's Golf",
  12: "Women's Sailing",
  13: "Women's Soccer",
  14: "Women's Softball",
  15: "Women's Swimming and Diving",
  16: "Women's Tennis",
  17: "Women's Track and Field",
  18: "Women's Volleyball",
  19: "Women's Water Polo",
  };

  const sportIdFromUrl = effectiveSportId ? Number(effectiveSportId) : null;
  const teamIdFromUrl  = effectiveTeamId  ? Number(effectiveTeamId)  : null;

  // const [filterState, setFilterState] = useState({
  //   sport: sportIdFromUrl
  //     ? { value: sportIdFromUrl, label: sportMap[sportIdFromUrl] || sportLabel || "" }
  //     : sportIdHome
  //     ? { value: sportIdHome, label: sportLabel }
  //     : { value: 2, label: sportMap[2] },
  const [filterState, setFilterState] = useState({
    sport: sportIdFromUrl
      ? { value: sportIdFromUrl, label: sportMap[sportIdFromUrl] || sportLabel || "" }
      : sportIdHome
      ? { value: sportIdHome, label: sportLabel }
      : { value: 2, label: sportMap[2] },
    conference: "",
    team: effectiveTeamId
      ? {
          value: Number(effectiveTeamId),
          label: isHawaii
            ? (HAWAII_TEAM_NAMES[hawaiiSportId] || "Hawai'i")
            : "",
        }
      : "",
    class: "",
    position: "",
    minAmount: 0,
    maxAmount: Number(maxWeight) || 100,
  });
  // Sync sport label when hawaii URL sport changes
useEffect(() => {
    if (isHawaii && sportIdFromUrl) {
      setFilterState((prev) => ({
        ...prev,
        sport: { value: sportIdFromUrl, label: sportMap[sportIdFromUrl] || prev.sport?.label || "" },
        team: {
          value: Number(effectiveTeamId),
          label: HAWAII_TEAM_NAMES[sportIdFromUrl] || "Hawai'i",
        },
      }));
    }
  }, [sportIdFromUrl]);

  const [playerFilter, setPlayerFilter] = useState("");

  const handleViewDetail = (player) => {
    const url = `/DetailsView/${player.player_id}/${player.team_id}?mode=${mode}`;
    window.open(url, "_blank");
  };

  const handleViewFanEngagement = (player) => {
    const url = `/FanExperience/${player.player_id}/${player.team_id}?mode=${mode}`;
    window.open(url, "_blank");
  };

  const handleViewBrandEngagement = (player) => {
    const url = `/BrandPartnership/${player.player_id}/${player.team_id}?mode=${mode}`;
    window.open(url, "_blank");
  };

  // ─────────────────────────────────────────────────────────
  // A) Single player by IDs
  // ─────────────────────────────────────────────────────────
  const fetchSingleByIds = async () => {
    if (!effectiveTeamId || !playerId) return;
    setLoading(true);
    try {
      const url = `${APIUrl()}/v1/get_player/${playerId}/${effectiveTeamId}`;
      const { data } = await axios.get(url, {
        headers: { "X-API-Key": APIUrlToken() },
      });

      setPlayers([data]);
      setPlayersCount(1);
      setLoadedPlayer(data);
      setIsFiltered(true);

      setFilterState((prev) => ({
        ...prev,
        sport: data?.sport_id
          ? { value: Number(data.sport_id), label: sportMap[data.sport_id] || prev?.sport?.label || "" }
          : prev.sport,
        team: {
          value: Number(data.team_id),
          label: data.team_name || prev.team?.label || "",
        },
        conference: data?.conference
          ? { value: data.conference, label: data.conference }
          : prev.conference,
        position: data?.position
          ? { value: data.position, label: data.position }
          : prev.position,
        class: data?.player_class
          ? { value: data.player_class, label: data.player_class }
          : prev.class,
      }));

      setPlayerFilter(data.player_name || "");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Player not found");
      setPlayers([]);
      setPlayersCount(0);
    } finally {
      setLoading(false);
    }
  };

  // ─────────────────────────────────────────────────────────
  // B) Team roster by ID
  // ─────────────────────────────────────────────────────────
  const PAGE_SIZE = 21;

  const fetchTeamPlayersById = async (isFirst) => {
    if (!effectiveTeamId) return;
    setLoading(true);
    try {
      if (isFirst) {
        setSkip(0);
        setPlayers([]);
        setPlayersCount(0);
        setApiCalled(false);
      }

      const url = `${APIUrl()}/v1/get_players_by_team/${effectiveTeamId}?limit=${PAGE_SIZE}&skip=${
        isFirst ? 0 : skip
      }`;

      const { data: resp } = await axios.get(url, {
        headers: { "X-API-Key": APIUrlToken() },
      });

      const count = resp?.total_count || 0;
      const list  = resp?.players || [];

      setPlayersCount(count);

      const first = list?.[0];
      if (first) {
        setFilterState((prev) => ({
          ...prev,
          sport: first?.sport_id
            ? { value: Number(first.sport_id), label: sportMap[first.sport_id] || prev?.sport?.label || "" }
            : prev.sport,
          // On Hawaii routes, keep the Hawaii team label; otherwise use API value
          team: {
            value: Number(effectiveTeamId),
            label: isHawaii
              ? (HAWAII_TEAM_NAMES[hawaiiSportId] || "Hawai'i")
              : (first?.team_name || prev.team?.label || ""),
          },
          conference: first?.conference
            ? { value: first.conference, label: first.conference }
            : prev.conference,
        }));
      }

      const sorted = [...list]
        .sort((a, b) => a.team_name.localeCompare(b.team_name))
        .sort((a, b) =>
          a.team_name === b.team_name
            ? a.player_name.localeCompare(b.player_name)
            : 0
        );

      if (isFirst) {
        setPlayers(sorted);
      } else {
        const merged = [...players, ...sorted]
          .sort((a, b) => a.team_name.localeCompare(b.team_name))
          .sort((a, b) =>
            a.team_name === b.team_name
              ? a.player_name.localeCompare(b.player_name)
              : 0
          );
        setPlayers(merged);
      }

      setIsFiltered(true);
      setApiCalled(true);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Failed to load team players");
      setApiCalled(true);
    } finally {
      setLoading(false);
    }
  };

  // ─────────────────────────────────────────────────────────
  // C) Generic filter-based fetch
  // ─────────────────────────────────────────────────────────
  const handleFilterData = (isFirst) => {
    setLoading(true);
    if (isFirst) {
      setSkip(0);
      setPlayers([]);
      setPlayersCount(0);
      setApiCalled(false);
    }

    const url = `${APIUrl()}/v1/v1/common_filter_players?limit=21&skip=${
      isFirst ? 0 : skip
    }`;

    const data = {};
    if (filterState?.sport?.value)       data.sport_id    = filterState.sport.value;
    if (filterState?.team?.value)        data.team_id     = Number(filterState.team.value);
    if (filterState?.conference?.value)  data.conference  = filterState.conference.value;
    if (filterState?.class?.value)       data.player_class = filterState.class.value;
    if (filterState?.position?.value)    data.position    = filterState.position.value;
    if (playerFilter && playerFilter.trim()) data.player_name = playerFilter.trim();

    axios
      .post(url, data, { headers: { "X-API-Key": APIUrlToken() } })
      .then((response) => {
        setIsFiltered(true);
        const resp = response?.data || {};
        const list = resp?.filtered_players || [];
        setPlayersCount(resp?.count || 0);

        const sorted = [...list]
          .sort((a, b) => a.team_name?.localeCompare(b.team_name))
          .sort((a, b) =>
            a.team_name === b.team_name
              ? a.player_name?.localeCompare(b.player_name)
              : 0
          );

        if (isFirst) {
          setPlayers(sorted);
        } else {
          setPlayers((prev) =>
            [...prev, ...sorted]
              .sort((a, b) => a.team_name?.localeCompare(b.team_name))
              .sort((a, b) =>
                a.team_name === b.team_name
                  ? a.player_name?.localeCompare(b.player_name)
                  : 0
              )
          );
        }

        setApiCalled(true);
        setTimeout(() => setLoading(false), 300);
      })
      .catch((error) => {
        setLoading(false);
        setApiCalled(true);
        toast.error(
          error?.response?.data?.error?.split(":")?.[1] ||
            error?.response?.data?.error ||
            "Failed to load players"
        );
      });
  };

  // ─────────────────────────────────────────────────────────
  // Effects
  // ─────────────────────────────────────────────────────────

  // Initial load: IDs first → then generic filters
  useEffect(() => {
    if (effectiveTeamId && playerId) {
      fetchSingleByIds();
    } else if (effectiveTeamId) {
      fetchTeamPlayersById(true);
    } else {
      if (isFiltered && skip > 0) {
        handleFilterData();
      } else {
        handleFilterData(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [effectiveSportId, effectiveTeamId, playerId]);

  // Pagination
  useEffect(() => {
    if (playerId) return;
    if (isFiltered && skip > 0) {
      if (effectiveTeamId) fetchTeamPlayersById(false);
      else handleFilterData(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [skip]);

  // Re-run when filters change (generic view only)
  useEffect(() => {
    if (!playerId && !effectiveTeamId) {
      const t = setTimeout(() => {
        handleFilterData(true);
      }, 600);
      return () => clearTimeout(t);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterState]);

  const handleNextClick = () => setSkip((prev) => prev + PAGE_SIZE);

  // const handleSearchPlayers = () => {
  //   setSkip(0);
  //   if (effectiveTeamId) {
  //     fetchTeamPlayersById(true);
  //   } else {
  //     handleFilterData(true);
  //   }
  // };
  const handleSearchPlayers = () => {
    setSkip(0);
    if (isHawaii && effectiveTeamId) {
      // On Hawaii routes, search by player name within the Hawaii team
      handleFilterData(true);
    } else if (effectiveTeamId) {
      fetchTeamPlayersById(true);
    } else {
      handleFilterData(true);
    }
  };

  const handleShowFilters = () => setShowFilters((prev) => !prev);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 767);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  // Derived values for passing to FiltersSidebar
  const scopedTeamId   = effectiveTeamId ? Number(effectiveTeamId) : null;
  const scopedTeamName = isHawaii
    ? (HAWAII_TEAM_NAMES[hawaiiSportId] || "Hawai'i")
    : (loadedPlayer?.team_name || players?.[0]?.team_name || filterState?.team?.label || "");

  return (
    <div>
      <Header />
      <div className="page-main-container">
        <PageHeadings showContribute={showContribute} />
        <div className="filter-sidebar-plus-dashcards">
          {isMobile && (
            <button onClick={handleShowFilters} className="show-filter-btn-dash">
              {showFilters ? "Hide Filters" : "Show Filters"}
            </button>
          )}
          {isMobile ? (
            showFilters ? (
              <FiltersSidebar
                setPlayers={setPlayers}
                loading={loading}
                setLoading={setLoading}
                setIsFiltered={setIsFiltered}
                skip={skip}
                filterState={filterState}
                setFilterState={setFilterState}
                handleFilterData={handleFilterData}
                setSkip={setSkip}
                maxWeight={maxWeight}
                setMaxWeight={setMaxWeight}
                handleSearchPlayers={handleSearchPlayers}
                playerFilter={playerFilter}
                setPlayerFilter={setPlayerFilter}
                loadedPlayer={loadedPlayer}
                scopedTeamId={scopedTeamId}
                scopedTeamName={scopedTeamName}
                isHawaii={isHawaii}
                hawaiiSportId={hawaiiSportId}
                hawaiiTeamMap={HAWAII_TEAM_MAP}
                hawaiiTeamNames={HAWAII_TEAM_NAMES}
              />
            ) : null
          ) : (
            <FiltersSidebar
              setPlayers={setPlayers}
              loading={loading}
              setLoading={setLoading}
              setIsFiltered={setIsFiltered}
              skip={skip}
              filterState={filterState}
              setFilterState={setFilterState}
              handleFilterData={handleFilterData}
              setSkip={setSkip}
              maxWeight={maxWeight}
              setMaxWeight={setMaxWeight}
              handleSearchPlayers={handleSearchPlayers}
              playerFilter={playerFilter}
              setPlayerFilter={setPlayerFilter}
              loadedPlayer={loadedPlayer}
              scopedTeamId={scopedTeamId}
              scopedTeamName={scopedTeamName}
              isHawaii={isHawaii}
              hawaiiSportId={hawaiiSportId}
              hawaiiTeamMap={HAWAII_TEAM_MAP}
              hawaiiTeamNames={HAWAII_TEAM_NAMES}
            />
          )}
          <DashboardsCards
            handleViewDetail={handleViewDetail}
            handleViewFanEngagement={handleViewFanEngagement}
            handleViewBrandEngagement={handleViewBrandEngagement}
            playersCount={playersCount}
            players={players}
            loading={loading}
            setLoading={setLoading}
            handleNextClick={handleNextClick}
            isFiltered={isFiltered}
            open={open}
            setOpen={setOpen}
            apiCalled={apiCalled}
            showContribute={showContribute}
            showCollab={showCollab}
            mode={mode}
          />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Dashboard;